import { MODE_ROOT, type ViewMode } from '../../shared/nav/viewMode';

/** Where the private event page's back link goes, carried in router state by
 *  the page that opened it. */
export interface PrivateEventReturn {
  from: { pathname: string; label: string };
}

const FALLBACK: Readonly<Record<ViewMode, { pathname: string; label: string }>> = {
  admin: { pathname: `${MODE_ROOT.admin}/private-events`, label: 'Private events' },
  teacher: { pathname: `${MODE_ROOT.teacher}/schedule`, label: 'My schedule' },
};

export function privateEventReturnState(pathname: string, label: string): PrivateEventReturn {
  return { from: { pathname, label } };
}

/** The back link's target. Only a path inside the page's own mode is trusted;
 *  anything else, or no state at all (a bookmark, a list click), returns to
 *  that mode's starting point: the list for admin, My schedule for a teacher. */
export function privateEventBackTarget(
  state: unknown,
  mode: ViewMode = 'admin',
): { pathname: string; label: string } {
  const from = (state as Partial<PrivateEventReturn> | null)?.from;
  const valid =
    typeof from?.pathname === 'string' &&
    from.pathname.startsWith(`${MODE_ROOT[mode]}/`) &&
    typeof from.label === 'string' &&
    from.label !== '';
  return valid ? from : FALLBACK[mode];
}
